export const scrollToTopSmooth = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
};

export const scrollToElement = (targetId: string) => {
    const el = document.getElementById(targetId);
    if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
};

/** Batches scroll/resize work into a single animation frame. */
export const createRafListener = (handler: () => void) => {
    let ticking = false;

    const onEvent = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
            handler();
            ticking = false;
        });
    };

    return onEvent;
};
